<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()"/>
      <div class="popup">
        <button class="popup-close" @click="closeModal()"></button>
        <span class="title">
          <slot name="header"/>
        </span>
        <div class="popup__body">
          <slot name="body"/>
        </div>

        <div class="popup__footer">
          <div class="form-bottom flex">
            <slot name="footer"/>
            <button class="link close-popup" @click="closeModal()"><span>Back to edit</span></button>
            <button v-if="confirmButton.text" class="button-icon" :class="confirmButton.class" @click="confirmAction">{{confirmButton.text}}</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  props: ['show', 'confirmButton'],
  methods: {
    confirmAction() {
      this.$emit('confirmAction')
      document.querySelector("body").classList.remove("overflow-hidden");
    },
    closeModal() {
      this.$emit('closeModal')
      document.querySelector("body").classList.remove("overflow-hidden")
    },
    openModal() {
      this.show = true;
      document.querySelector("body").classList.add("overflow-hidden")
    }
  }
};
</script>


<style lang="scss" scoped>
.modal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  &__dialog {
    height: 608px;
    width: 70%;
    background-color: #ffffff;
    position: relative;
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    z-index: 2;
    @media screen and (max-width: 992px) {
      width: 90%;
    }
  }
  &__close {
    width: 30px;
    height: 30px;
  }
  &__header {
    padding: 20px 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  &__body {
    padding: 10px 20px 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__footer {
    padding: 10px 20px 20px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.popup__body {
    color: rgb(21, 1, 29);
    font-size: 20px;
    font-weight: 300;
    letter-spacing: 0.12px;
    line-height: 30px;
}
</style>
